let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jooWD")).then(() => parcelRequire('9XKDI'));